import { render, staticRenderFns } from "./AuthorityTypeList.vue?vue&type=template&id=04e8b6b9"
import script from "./AuthorityTypeList.vue?vue&type=script&lang=js"
export * from "./AuthorityTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports